import { Avatar, Button, CircularProgress, Grid } from '@material-ui/core';
import React from 'react';
import CustomAppBar from '../../commons/AppBar';
import SpecificComponent from '../../commons/SpecificComponent';
import LocalStorage from '../../providers/LocalStorage';
import Utils from '../../providers/Utils';
import Ws from '../../providers/Ws';
import WsC from './providers/WsC';

import { ReactComponent as TrashAltSolid } from './Icoane Font Awesome/trash-alt-solid.svg'
import { ReactComponent as EyeSolid } from './Icoane Font Awesome/eye-solid.svg'
import { ReactComponent as ChartBarSolid } from './Icoane Font Awesome/chart-bar-solid.svg'

import AlertNew from '../../commons/dialogs/AlertNew';
import ChartsChestionare from './ChartsChestionare';
import RaportChestionare from './RaportChestionare';


export default class EvaluariSesiune extends SpecificComponent {
    constructor(props) {
        super(props);
        this.state = {
            evaluari: [],
            sesiune: {},
            openDeleteEvaluare: false,
            evaluareSelectata: {},
            checkRaport: false,
            raspunsuriAll: [],
            raport: { raport_data: { intrebari: [] } },
            openRaport: false,
            angajatiSelectati: 0,
            rapoarte: [],
            openDeleteRaport: false,
            popUpRaport: false,
            openDeleteEvaluare: false,
            openDeleteRaport: false,
            loading: false,
            alertView:false
        }
    }

    componentDidMount() {
        this.access()
        this.getSesiune()

    }

    u = new Utils()

    access = async () => {



        console.log('this.ls.InfoUser.IsAdmin :>> ', this.ls.InfoUser.IsAdmin);

        if (this.ls.InfoUser.IsAdmin !== 1) {


            this.setState({ alertView: this.ls.InfoUser.EsteSef === 1 ? false : true })
        }


    }

    ws = new WsC()
    wsP = new Ws()
    ls = new LocalStorage().GetUserData()
    u = new Utils()



    titluPagina = () => {
        if (this.props.match.params.tip === 'evaluare_angajati') {

            return this.dictionary.pontaje.evaluareColegi
        } else if (this.props.match.params.tip === 'evaluare_sefi') {

            return this.dictionary.pontaje.evaluareManager
        } else {
            return this.dictionary.pontaje.evaluareClienti
        }
    }


    addEvaluare = () => {

        if (this.props.match.params.tip === 'evaluare_angajati') {

            this.props.history.push(`/evaluarenouacolegi/${this.props.match.params.idsesiune}/0`)
        } else if (this.props.match.params.tip === 'evaluare_sefi') {

            this.props.history.push(`/evaluarenouasefi/${this.props.match.params.idsesiune}/0`)
        } else {
            this.props.history.push(`/evaluarenouaclienti/${this.props.match.params.idsesiune}/0`)
        }
    }

    goToEvaluare = async (e) => {

        console.log('e :>> ', e);

        let intrebari = [...this.state.intrebari]

        let dep = [...this.state.evaluari]



        for (let i = 0, n = intrebari.length; i < n; i++) {


            for (let j = 0, m = intrebari[i].raspunsuri.length; j < m; j++) {

                intrebari[i].raspunsuri[j].rezultate = []
                intrebari[i].raspunsuri[j].rezultate_evaluare = []

                let sumaRaspuns = 0

                for (let k = 0, q = dep.length; k < q; k++) {

                    for (let p = 0, o = dep[k].evaluari.length; p < o; p++) {
                        if (dep[k].evaluari[p].id === e.id) {
                            let filterRaspunsuriOptiuneRaspuns = dep[k].evaluari[p].raspunsuri.filter(rasp => rasp.id_optiune_raspuns === intrebari[i].raspunsuri[j].id_optiune_raspuns)

                            filterRaspunsuriOptiuneRaspuns = filterRaspunsuriOptiuneRaspuns.filter(rasp => rasp.raspuns !== null)
                            filterRaspunsuriOptiuneRaspuns = filterRaspunsuriOptiuneRaspuns.filter(rasp => rasp.statusul === 'Finalizat')



                            sumaRaspuns = this.u.round(( ((filterRaspunsuriOptiuneRaspuns.length * 100) / dep[k].evaluari[p].completari_finalizate) || 0), 2 )
                            console.log('filterRaspunsuriOptiuneRaspuns :>> ', filterRaspunsuriOptiuneRaspuns);
                            console.log('sumaRaspuns :>> ', sumaRaspuns);

                            if (sumaRaspuns === 0) {
                                sumaRaspuns = 1
                            }
                            intrebari[i].raspunsuri[j].rezultate.push(sumaRaspuns)
                            console.log('dep[k].evaluari[p] :>> ', dep[k].evaluari[p]);
                            intrebari[i].raspunsuri[j].rezultate_evaluare.push(dep[k].evaluari[p].nume_user)
                        }
                    }
                }
            }
        }

        console.log('intrebari :>> ', intrebari);

        let raportData = { completare: this.state.sesiune.procent_completare, intrebari: intrebari, completare_color: this.state.sesiune.color }

        let raport = {
            id_sesiune: this.props.match.params.idsesiune,
            titlu: '',
            la_data: this.u.updateSqlNow(),
            nr_evaluari: 1,
            finalizat_la_creare: this.state.sesiune.finalizat === 1 ? 1 : 0,
            raport_data: JSON.stringify(raportData)

        }



        console.log('raport :>> ', raport);
        ///////INSERT RAPORT

        let insertRaport = await this.ws.insert('rapoarte_salvate_head', raport)

        console.log('insertRaport :>> ', insertRaport);

        if (insertRaport.Succes) {

            raport.raport_data = JSON.parse(raport.raport_data)
            raport.id = insertRaport.Content[0].id
            this.setState({
                checkRaport: false,
                popUpRaport: false,
                openRaport: true,
                raport: raport
            }, () => {
                this.getSesiune()
            })
        }
    }

    openStergeEvaluare = (e) => {
        this.setState({
            openDeleteEvaluare: true,
            evaluareSelectata: e
        })
    }


    stergeEvaluare = async () => {

        let delEval = await this.ws.update('evaluari', { inactiv: 1 }, { id: this.state.evaluareSelectata.id })

        if (delEval.Succes) {



            this.setState({ openDeleteEvaluare: false }, () => {
                this.getSesiune()
            })
        }
    }

    returnButton = () => {
        let rez = []




        rez.push(<div key={1}>
            <Button style={{ display: this.props.displayInsert === 1 ? 'none' : 'inline-flex', padding: 10, backgroundColor: 'rgb(24 166 59)', color: 'white', fontWeight: 500 }} onClick={this.addEvaluare}  >
                <i className='material-icons pm-round-button-text'>add</i>
                {this.dictionary.evaluari.evaluareNoua}
            </Button>
        </div>)




        return rez
    }


    getSesiune = async () => {

        let q = `select s.*, (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1)) as completari_toate,
        (select count(*) from raspunsuri_head where id_evaluare in (select id from evaluari where id_sesiune = s.id and isnull(inactiv,0) != 1) and statusul = @p2) as completari_finalizate from sesiuni s where s.id = @p1 and isnull(s.sters,0) != 1 `



        let sesiune = this.ws.customSelect(q, { p1: this.props.match.params.idsesiune, p2: 'Finalizat' })


        let evaluari = this.ws.customSelect(`select e.*, a.poza, a.functie, a.nume as nume_user, (select count(*) from raspunsuri_head where id_evaluare = e.id and statusul = @p1) as completari_finalizate, 
                                                         (select count(*) from raspunsuri_head where id_evaluare = e.id ) as completari_toate
                                            from evaluari e left join [${this.ls.InfoUser.Database}].[dbo].[angajati] a on a.id_user = e.id_user_aprobare
                                             where e.id_sesiune = @p2 and isnull(e.inactiv,0) != 1 ` , {
            p1: 'Finalizat',
            p2: this.props.match.params.idsesiune
        })
        let departamente = this.wsP.customSelect(`select * from departamente where isnull(inactiv,0) != 1`, { p1: 1 })



        let _raspunsuri = this.ws.customSelect(`select r.*, h.id_evaluare from raspunsuri_intrebari r left join raspunsuri_head h on r.id_head = h.id
                                            where h.id_evaluare in (select id from evaluari where id_sesiune = @p1 and isnull(inactiv,0) != 1) order by isnull(ordinea,0) asc, id`, {
            p1: this.props.match.params.idsesiune
        })

        let _optiuniRaspuns = this.ws.customSelect(`select r.*, h.id_evaluare, h.statusul from raspunsuri_intrebari_raspunsuri r left join raspunsuri_head h on r.id_head = h.id 
                                                    where h.id_evaluare in (select id from evaluari where id_sesiune = @p1 and isnull(inactiv,0) != 1) order by r.id_optiune_raspuns asc`, {
            p1: this.props.match.params.idsesiune,

        })

        let rapoarte = this.ws.customSelect(`select * from rapoarte_salvate_head where id_sesiune = @p1 and isnull(sters,0) != 1`, { p1: this.props.match.params.idsesiune })

        let [e, s, d, opr, r, rap] = await Promise.all([evaluari, sesiune, departamente, _optiuniRaspuns, _raspunsuri, rapoarte])

        console.log('e :>> ', e);
        console.log('s :>> ', s);
        console.log('d :>> ', d);
        console.log('opr :>> ', opr);
        console.log('rap :>> ', rap);

        if (e.Succes && s.Succes && d.Succes && opr.Succes && r.Succes && rap.Succes) {
            let depNew = []

            let dep = [...d.Content]
            let evaluari = [...e.Content]
            let optiuniR = [...opr.Content]
            let intrebari = [...r.Content]


            let punctajMaxim = 0

            punctajMaxim = optiuniR.reduce((a, r) => { return a + (r.puncte || 0) }, 0)

            punctajMaxim = punctajMaxim / evaluari.length

            for (let i = 0, n = dep.length; i < n; i++) {
                let filterE = evaluari.filter(eva => eva.id_departament === dep[i].id)

                if (filterE.length > 0) {


                    for (let j = 0, m = filterE.length; j < m; j++) {
                        let pct = 0



                        console.log('punctajMaxim :>> ', punctajMaxim);

                        console.log('filterE[j] :>> ', filterE[j]);


                        let filterR = optiuniR.filter(o => o.id_evaluare === filterE[j].id)

                        if (filterR.length > 0) {
                            for (let k = 0, l = filterR.length; k < l; k++) {


                                pct += filterR[k].raspuns ? filterR[k].puncte : 0 || 0
                            }

                            filterE[j].puncte = pct
                        }

                        filterE[j].procent_completare = Math.floor(((filterE[j].completari_finalizate * 100) / filterE[j].completari_toate) || 0)

                        filterE[j].color = filterE[j].procent_completare >= 80 ? 'rgb(24 165 58)' : (filterE[j].procent_completare < 80 && filterE[j].procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                        filterE[j].color_puncte = filterE[j].puncte >= (punctajMaxim - (punctajMaxim / 3)) ? 'rgb(24 165 58)' : (filterE[j].puncte < (punctajMaxim - (punctajMaxim / 3)) && filterE[j].puncte >= (punctajMaxim / 2) ? 'rgb(227 154 10)' : 'rgb(252,93,98)')
                        filterE[j].checked = false
                        filterE[j].raspunsuri = filterR



                    }

                    dep[i]['evaluari'] = filterE
                    dep[i]['checked'] = false

                    depNew.push(dep[i])
                }
            }


            let session = { ...s.Content[0] }

            session.procent_completare = Math.floor(((session.completari_finalizate * 100) / session.completari_toate) || 0)

            session.color = session.procent_completare >= 80 ? 'rgb(24 165 58)' : (session.procent_completare < 80 && session.procent_completare >= 50 ? 'rgb(227 154 10)' : 'rgb(252,93,98)')


            console.log('session :>> ', session);



            let intrebariNew = []


            for (let k = 0, l = intrebari.length; k < l; k++) {


                let idx = intrebariNew.findIndex(int => Number(int.id_intrebare) === Number(intrebari[k].id_intrebare))

                if (idx === -1) {


                    let filterRaspunsuri = optiuniR.filter(ras => Number(ras.id_head) === Number(intrebari[k].id_head))
                    filterRaspunsuri = filterRaspunsuri.filter(ras => Number(ras.id_intrebare) === Number(intrebari[k].id_intrebare))

                    intrebari[k].raspunsuri = filterRaspunsuri

                    intrebariNew.push(intrebari[k])


                }
            }

            console.log('intrebariNew :>> ', intrebariNew);
            this.setState({
                evaluari: depNew,
                sesiune: session,
                intrebari: intrebariNew,
                raspunsuriAll: optiuniR,
                rapoarte: rap.Content

            })

            console.log('depNew :>> ', depNew);

        }

    }




    buildAppBarButtons = () => {
        let rez = []

        rez.push(<div>
            <span style={{ color: 'black', marginRight: 10 }}>Astazi:{this.dataAzi()} </span>
        </div>)

        return rez
    }


    dataAzi = () => {


        let dataAzi = this.u.defaultData()

        if (this.dictionary.date === 'en') {
            return this.u.dataPrescurtataEng(dataAzi)
        } else {
            return this.u.dataPrescurtataRomana(dataAzi)
        }
    }

    selecteazaDepartament = (d) => {

        let departamente = [...this.state.evaluari]


        let angajatiSelectati = this.state.angajatiSelectati
        let idx = departamente.findIndex(dep => dep.id === d.id)



        if (idx !== -1) {

            departamente[idx]['checked'] = !departamente[idx]['checked']



            for (let i = 0, n = departamente[idx].evaluari.length; i < n; i++) {


                if (departamente[idx].evaluari[i]['checked'] !== departamente[idx]['checked']) {
                    departamente[idx].evaluari[i]['checked'] = departamente[idx]['checked']

                    if (departamente[idx].evaluari[i]['checked']) {
                        if (departamente[idx].evaluari[i]['checked']) {
                            angajatiSelectati += 1
                        } else {
                            angajatiSelectati -= 1
                        }
                    }
                }

            }


        }

        this.setState({
            departamente: departamente,
            angajatiSelectati: angajatiSelectati
        })
    }

    selecteazaEvaluare = (a) => {

        let departamente = [...this.state.evaluari]

        let angajatiSelectati = this.state.angajatiSelectati

        let idxDep = departamente.findIndex(dep => dep.id === a.id_departament)

        console.log('idxDep :>> ', idxDep);

        console.log('a :>> ', a);
        if (idxDep !== -1) {
            let idxA = departamente[idxDep].evaluari.findIndex(ang => ang.id === a.id)

            if (idxA !== -1) {
                departamente[idxDep].evaluari[idxA]['checked'] = !departamente[idxDep].evaluari[idxA]['checked']
                if (!departamente[idxDep].evaluari[idxA]['checked'] === false) {

                    angajatiSelectati += 1
                } else {
                    angajatiSelectati -= 1
                    departamente[idxDep]['checked'] = false

                }

                let filterDep = departamente[idxDep].evaluari.filter(ang => ang.checked)


                console.log('filterDep :>> ', filterDep);
                if (departamente[idxDep].evaluari.length === filterDep.length) {
                    departamente[idxDep]['checked'] = true
                }

            }

            this.setState({
                angajatiSelectati: angajatiSelectati,
                evaluari: departamente
            })
        }

    }

    creeazaRaport = async () => {


        this.setState({ loading: true }, async () => {
            if (this.state.checkRaport) {

                let intrebari = [...this.state.intrebari]

                let dep = [...this.state.evaluari]

                for (let i = 0, n = intrebari.length; i < n; i++) {


                    for (let j = 0, m = intrebari[i].raspunsuri.length; j < m; j++) {

                        intrebari[i].raspunsuri[j].rezultate = []
                        intrebari[i].raspunsuri[j].rezultate_evaluare = []

                        let sumaRaspuns = 0

                        for (let k = 0, q = dep.length; k < q; k++) {

                            for (let p = 0, o = dep[k].evaluari.length; p < o; p++) {
                                console.log('dep[k].evaluari :>> ', dep[k].evaluari[p]);
                                if (dep[k].evaluari[p].checked) {
                                    let filterRaspunsuriOptiuneRaspuns = dep[k].evaluari[p].raspunsuri.filter(rasp => rasp.id_optiune_raspuns === intrebari[i].raspunsuri[j].id_optiune_raspuns)

                                    filterRaspunsuriOptiuneRaspuns = filterRaspunsuriOptiuneRaspuns.filter(rasp => rasp.raspuns !== null)
                                    filterRaspunsuriOptiuneRaspuns = filterRaspunsuriOptiuneRaspuns.filter(rasp => rasp.statusul === 'Finalizat')

                                    console.log('filterRaspunsuriOptiuneRaspuns22222 :>> ', filterRaspunsuriOptiuneRaspuns);
                                    console.log('filterRaspunsuriOptiuneRaspuns :>> ', filterRaspunsuriOptiuneRaspuns);


                                    sumaRaspuns = +(Math.round(((filterRaspunsuriOptiuneRaspuns.length * 100) / dep[k].evaluari[p].completari_finalizate) + "e+1") + "e-1");




                                    console.log('dep[k].evaluari[p] :>> ', dep[k].evaluari[p]);
                                    // console.log('filterRaspunsuriOptiuneRaspuns :>> ', filterRaspunsuriOptiuneRaspuns);
                                    if (sumaRaspuns === 0) {
                                        sumaRaspuns = 1
                                    }
                                    intrebari[i].raspunsuri[j].rezultate.push(sumaRaspuns)
                                    // console.log('dep[k].evaluari[p] :>> ', dep[k].evaluari[p]);
                                    intrebari[i].raspunsuri[j].rezultate_evaluare.push(dep[k].evaluari[p].nume_user)
                                }
                            }
                        }
                    }
                }

                console.log('intrebari :>> ', intrebari);

                let raportData = { completare: this.state.sesiune.procent_completare, intrebari: intrebari, completare_color: this.state.sesiune.color }

                let raport = {
                    id_sesiune: this.props.match.params.idsesiune,
                    titlu: '',
                    la_data: this.u.updateSqlNow(),
                    nr_evaluari: this.state.angajatiSelectati,
                    finalizat_la_creare: this.state.sesiune.finalizat === 1 ? 1 : 0,
                    raport_data: JSON.stringify(raportData)

                }



                console.log('raport :>> ', raport);
                ///////INSERT RAPORT

                let insertRaport = await this.ws.insert('rapoarte_salvate_head', raport)

                console.log('insertRaport :>> ', insertRaport);

                if (insertRaport.Succes) {

                    raport.raport_data = JSON.parse(raport.raport_data)
                    raport.id = insertRaport.Content[0].id
                    this.setState({
                        checkRaport: false,
                        popUpRaport: false,
                        openRaport: true,
                        raport: raport,
                        loading: false,
                        angajatiSelectati: 0
                    }, () => {
                        this.getSesiune()
                    })
                }

                ////insert succes



            } else {
                this.setState({
                    checkRaport: true,
                    popUpRaport: true,
                    loading: false
                })
            }
        })



    }

    exportaRaport = () => {

    }

    raportTitluChange = (ev) => {
        let raport = { ...this.state.raport }

        raport['titlu'] = ev.target.value

        this.setState({ raport: raport })
    }

    updateTitluRaport = async () => {


        let updateRaport = await this.ws.update('rapoarte_salvate_head', { titlu: this.state.raport.titlu }, { id: this.state.raport.id })


        if (updateRaport.Succes) {
            this.getSesiune()
        }
    }

    goToRaport = (r) => {

        let raport = { ...r }
        raport.raport_data = JSON.parse(raport.raport_data)
        this.setState({
            raport: raport,
            openRaport: true
        })
    }

    stergeRaport = async () => {

        let sRaport = await this.ws.update('rapoarte_salvate_head', { sters: 1 }, { id: this.state.raport.id })

        if (sRaport.Succes) {

            this.setState({
                openDeleteRaport: false
            }, () => {

                this.getSesiune()
            })
        }
    }

    openStergeRaport = (r) => {

        let raport = { ...r }

        raport.raport_data = JSON.parse(raport.raport_data)

        this.setState({
            openDeleteRaport: true,
            raport: raport
        })
    }


    finalizeazaSesiunea = async () => {

        let updateSes = await this.ws.update('sesiuni', { finalizat: 1 }, { id: this.props.match.params.idsesiune })

        if (updateSes.Succes) {
            this.getSesiune()
        }
    }


    render() {
        return (
            <div>
                <CustomAppBar title={this.returnButton()} history={this.props.history} appBarButtons={this.buildAppBarButtons()} />

                <AlertNew
                    open={this.state.alertView}
                    dialogClose={() => { this.setState({ alertView: false }) }}
                    title={this.dictionary.proiecte.alertView}
                    mesaj={this.dictionary.proiecte.alertViewMessage}
                    noButtonDisplay={1}
                    yesFunction={() => { this.props.history.replace('/') }}
                    fullScreen={true}
                />
                
                <AlertNew
                    open={this.state.openDeleteEvaluare}
                    dialogClose={() => { this.setState({ openDeleteEvaluare: false }) }}
                    title={this.dictionary.evaluari.alertStergeEvaluare}
                    mesaj={this.dictionary.evaluari.alertStergeEvaluareMessage}
                    yesFunction={this.stergeEvaluare}
                    deleteP={true}
                />

                <AlertNew
                    open={this.state.openDeleteRaport}
                    dialogClose={() => { this.setState({ openDeleteRaport: false }) }}
                    title={this.dictionary.evaluari.alertStergeRaport}
                    mesaj={this.dictionary.evaluari.alertStergeRaportMessage}
                    yesFunction={this.stergeRaport}
                    deleteP={true}
                />

                <RaportChestionare
                    open={this.state.openRaport}
                    dialogClose={() => { this.setState({ openRaport: false }) }}
                    raport={this.state.raport}
                    raportTitluChange={this.raportTitluChange}
                    sesiune={this.state.sesiune}
                    exportaRaport={this.exportaRaport}
                    updateTitluRaport={this.updateTitluRaport}
                    titlu={this.titluPagina()}
                />

                {this.state.loading &&
                    <div className='loading-div' >

                        <CircularProgress
                            style={{
                                width: 60,
                                height: 60,
                                color: '#25e048',
                                marginTop: '40%'
                            }}
                            value={20}

                        />
                        <span style={{ display: 'block', fontSize: 20 }}>Loading...</span>
                    </div>
                }


                <Grid style={{ maxWidth: 1000, margin: 'auto' }} container>

                    <Grid item xs={9} sm={9} md={9} lg={9} xl={9}>
                        <h1 style={{ margin: '80px 0 40px 0' }} className='pm-title-big'>{this.titluPagina()} </h1>
                    </Grid>

                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>

                        {!this.state.sesiune.finalizat &&
                            <Button
                                disabled={this.state.creeazaEvaluareDisabled}
                                className={this.state.creeazaEvaluareDisabled ? 'add-button-disabled' : 'add-button-red'}
                                style={{ margin: '90px 0 40px 0' }} onClick={this.finalizeazaSesiunea}  >

                                {this.dictionary.evaluari.finalizeazaSesiunea}
                            </Button>
                        }

                    </Grid>


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid container>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <h4 style={{ textAlign: 'left', fontWeight: 400 }}>{this.dictionary.evaluari.sesiunea}: <span style={{ fontWeight: 600 }}>{this.state.sesiune.nume}</span></h4>
                            </Grid>
                            <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                <h4 style={{ textAlign: 'left', fontWeight: 400 }}>{this.dictionary.evaluari.completareNoCaps}: <span style={{ fontWeight: 600, color: this.state.sesiune.color }}>{this.state.sesiune.procent_completare}%</span>

                                    <span style={{ marginLeft: 20 }}>{this.dictionary.evaluari.finalizatNoCaps}: <span style={{ color: this.state.sesiune.finalizat !== null ? 'rgb(24 165 58)' : 'red', fontWeight: 600 }}>{this.state.sesiune.finalizat !== null ? 'DA' : 'NU'}</span> </span>
                                </h4>
                            </Grid>

                        </Grid>

                    </Grid>

                    {this.state.popUpRaport &&
                        <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                            <div style={{ display: 'flex', justifyContent: "space-between", backgroundColor: 'rgb(114 227 254)', borderRadius: 30, padding: 10, marginTop: 20, marginBottom: 20, textAlign: 'left' }}>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'middle' }} className='material-icons'>error</i>
                                    <span style={{ fontSize: 11, fontWeight: 500 }}>
                                        {this.dictionary.evaluari.persoaneRaport}
                                    </span>
                                </div>
                                <div>
                                    <i style={{ fontSize: 18, verticalAlign: 'bottom', cursor: "pointer" }} onClick={() => { this.setState({ popUpRaport: false }) }} className='material-icons'>clear</i>
                                </div>

                            </div>
                        </Grid>
                    }


                    <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                        <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                            {this.state.evaluari.map((d, idx) => {
                                return (
                                    <Grid key={idx} item xs={12} sm={12} md={12} lg={12} xl={12}>
                                        <Grid container>
                                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

                                                <h4 style={{ textAlign: 'left', fontWeight: 400, paddingLeft: this.state.checkRaport ? 11 : 0 }}>
                                                    {this.state.checkRaport &&
                                                        <span >
                                                            {d.checked ?
                                                                <i onClick={() => { this.selecteazaDepartament(d) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-departament' >check_box</i>
                                                                : <i onClick={() => { this.selecteazaDepartament(d) }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                            }
                                                        </span>
                                                    }


                                                    {this.dictionary.evaluari.departament} : {d.nume}</h4>
                                            </Grid>

                                            {d.evaluari.map((e, idx2) => {
                                                return (


                                                    <Grid style={{ textAlign: 'left', marginBottom: 20, background: 'rgb(249,249,249)', padding: 10 }} key={idx2} container>



                                                        <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                            {this.state.checkRaport &&
                                                                <span >
                                                                    {e.checked ?
                                                                        <i onClick={() => { this.selecteazaEvaluare(e) }} style={{ color: '#80cd5a' }} className='material-icons checkbox-departament' >check_box</i>
                                                                        : <i onClick={() => { this.selecteazaEvaluare(e) }} className='material-icons checkbox-departament' >check_box_outline_blank</i>
                                                                    }
                                                                </span>
                                                            }


                                                            {e.poza &&
                                                                <div
                                                                    className='pm-angajati-picture'
                                                                    style={{ backgroundImage: `url('${this.wsP.adresaMedia + '/Angajati/' + e.poza}')`, width: 36, height: 36, padding: 5 }}>

                                                                </div>
                                                            }
                                                            {!e.poza &&

                                                                <Avatar
                                                                    className='pm-angajati-picture'
                                                                    style={{ display: 'inline-block', textAlign: 'center', height: 36, width: 36, backgroundColor: this.u.culoriUtilizatori(e.id), padding: 5, cursor: 'pointer' }}>
                                                                    <i style={{ verticalAlign: 'middle' }} className='material-icons'>person</i>
                                                                </Avatar>
                                                            }
                                                        </Grid>


                                                        <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                            <Grid container>

                                                                <Grid style={{ paddingTop: 5 }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400 }}>{e.nume_user}</span>
                                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>{e.functie}</span>

                                                                </Grid>
                                                                <Grid style={{ textAlign: 'left' }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                                    {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.data} </span>
                                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400 }}>{this.u.ParseDataFromSql(e.cand_creat)}</span>

                                                                </Grid>

                                                                <Grid style={{ textAlign: 'left' }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                                    {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.evaluatori} </span>
                                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400 }}>{e.completari_toate}</span>


                                                                </Grid>
                                                                <Grid style={{ textAlign: 'left', paddingLeft: 10 }} item xs={2} sm={2} md={2} lg={2} xl={2}>

                                                                    {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.completareNoCaps} </span>
                                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400 }}>{e.procent_completare}%</span>


                                                                </Grid>
                                                                <Grid style={{ textAlign: 'left' }} item xs={1} sm={1} md={1} lg={1} xl={1}>

                                                                    {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                                    <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>{this.dictionary.evaluari.puncte} </span>
                                                                    <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 400, color: e.color_puncte }}>{e.puncte}</span>


                                                                </Grid>


                                                                {!this.state.sesiune.finalizat &&
                                                                    <Grid style={{
                                                                        justifyContent: 'flex-end',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                        <TrashAltSolid className=' iconSvg' onClick={() => { this.openStergeEvaluare(e) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                                        <EyeSolid className=' iconSvg' onClick={() => { this.goToEvaluare(e) }} style={{ marginLeft: 20, width: 18, height: 18 }} />

                                                                        {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                                                    </Grid>
                                                                }


                                                                {this.state.sesiune.finalizat &&
                                                                    <Grid style={{
                                                                        justifyContent: 'flex-end',
                                                                        display: 'flex',
                                                                        alignItems: 'center'
                                                                    }} item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                                        <TrashAltSolid className=' iconSvg' style={{ marginRight: 0, width: 18, height: 18, color: 'gray' }} />
                                                                        <EyeSolid onClick={() => { this.goToEvaluare(e) }} className=' iconSvg' style={{ marginLeft: 10, width: 18, height: 18, color: 'gray' }} />

                                                                        {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                                                    </Grid>
                                                                }



                                                            </Grid>

                                                        </Grid>



                                                    </Grid>
                                                )
                                            })}
                                        </Grid>
                                    </Grid>
                                )

                            })}
                            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container>
                                    <Grid style={{ textAlign: 'left' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Button
                                            disabled={this.state.checkRaport || this.state.sesiune.finalizat === 1}
                                            className={(this.state.checkRaport || this.state.sesiune.finalizat === 1) ? 'add-button-disabled' : 'add-button-green'}
                                            onClick={this.addEvaluare}  >

                                            {this.dictionary.evaluari.evaluareNoua}
                                        </Button>
                                    </Grid>
                                    <Grid style={{ textAlign: 'right' }} item xs={6} sm={6} md={6} lg={6} xl={6}>
                                        <Button

                                            className='add-button-blue'
                                            onClick={this.creeazaRaport}  >
                                            <ChartBarSolid className=' iconSvg' style={{ marginRight: 10, width: 16, height: 16 }} />
                                            {this.dictionary.evaluari.creeazaRaport} 
                                </Button>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>


                    <Grid style={{ marginTop: 20 }} item xs={12} sm={12} md={12} lg={12} xl={12}>
                        {this.state.rapoarte.length > 0 &&
                            <Grid container style={{ padding: 20, position: 'relative', backgroundColor: 'white', marginBottom: 40 }}>
                                {this.state.rapoarte.map((r, idx) => {
                                    return (
                                        <Grid style={{ textAlign: 'left', marginBottom: 20, background: 'rgb(249,249,249)', padding: 10 }} key={idx} container>
                                            <Grid style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }} item xs={1} sm={1} md={1} lg={1} xl={1}>
                                                <ChartBarSolid onClick={() => { this.setState({ openSettings: this.state.openSettings ? false : true }) }} className='iconSvg' style={{ verticalAlign: 'bottom', cursor: 'pointer' }} />


                                            </Grid>


                                            <Grid item xs={11} sm={11} md={11} lg={11} xl={11}>
                                                <Grid container>
                                                    <Grid item xs={3} sm={3} md={3} lg={3} xl={3}>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{r.titlu}</span>
                                                        <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', }}>{r.nr_evaluari} persoane</span>

                                                    </Grid>
                                                    <Grid style={{ textAlign: 'left' }} item xs={4} sm={4} md={4} lg={4} xl={4}>

                                                        {/* <span style={{ marginRight: 20, fontSize: 12, display:'block', lineHeight:2 }}>Valoare:<span style={{fontWeight:600}}>{t.suma_cheltuieli.toFixed(3)}</span></span> */}
                                                        <span className='textSecondary' style={{ marginRight: 20, fontSize: 12, display: 'block', fontWeight: 400 }}>  {this.dictionary.evaluari.data} </span>
                                                        <span style={{ marginRight: 20, fontSize: 14, display: 'block', fontWeight: 600 }}>{this.u.ParseDataFromSql(r.la_data)}</span>


                                                    </Grid>

                                                    <Grid style={{
                                                        justifyContent: 'flex-end',
                                                        display: 'flex',
                                                        alignItems: 'center'
                                                    }} item xs={5} sm={5} md={5} lg={5} xl={5}>
                                                        <TrashAltSolid className=' iconSvg' onClick={() => { this.openStergeRaport(r) }} style={{ marginRight: 0, width: 18, height: 18 }} />
                                                        <EyeSolid className=' iconSvg' onClick={() => { this.goToRaport(r) }} style={{ marginLeft: 10, width: 18, height: 18 }} />

                                                        {/* <i onClick={() => { this.props.intrebare.tip !== 'grupaj' ? this.props.deleteRaspuns(r) : this.deleteRaspuns(r) }} style={{ marginRight: 0, }} className="material-icons iconFontSize textSecondary">delete</i> */}

                                                    </Grid>
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    )

                                })}
                            </Grid>
                        }
                    </Grid>




                </Grid>
            </div>
        );
    }
}